angular.module('permanentUnitModule').component('permanentUnitPriceHistory', {
    templateUrl: 'permanentUnitPriceHistory/permanentUnitPriceHistory.html',
    bindings: {
        rpc: '@',
        showLatestOnly: '@',
        isRental: '@',
        mobileMode: '@'
    },
    controller: ['PubSub', '$http', '$timeout', '$sce', '$compile', 'StateService', 'gVariables', 'crResourcesService', 'ImageService',
        function (PubSub, $http, $timeout, $sce, $compile, StateService, gVariables, crResourcesService, ImageService) {
            var ctrl = this;
            
            ctrl.$onInit = function() {
                ctrl.loadingData = false;
                ctrl.sections = [];
                ctrl.loadData();
            };

            ctrl.isRentalSection = function(section) {
                return section.status_class == 'rent' || section.status_class == 'rented' || section.status_class == 'in-contract-rent';
            };

            ctrl.filterSectionsByType = function(sections) {
                if (ctrl.isRental == 'true') {
                    return sections.filter(ctrl.isRentalSection);
                } else if (ctrl.isRental == 'false') {
                    return sections.filter(function(section) {
                        return !ctrl.isRentalSection(section) && section.status_class != 'off-market';
                    });
                }
                return sections;
            };

            ctrl.loadData = function () {
                if (!ctrl.rpc) return;

                ctrl.loadingData = true;

                $http({
                    method: 'GET',
                    url: ctrl.rpc,
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                }).then(function successCallback(response) {
                    ctrl.sections = response.data.sections || [];
                    
                    ctrl.sections = ctrl.filterSectionsByType(ctrl.sections);
                    
                    if (ctrl.showLatestOnly === 'true' && ctrl.sections.length > 0) {
                        ctrl.sections = [ctrl.sections[0]];
                    }
                    
                    if (!ctrl.sections.length) {
                        var element = document.querySelector('permanent-unit-price-history');
                        if (element && element.parentNode) {
                            var priceHistoryTab = element.closest('.tab.price_history');

                            // Remove the listing history section (existing behavior)
                            if (element.parentNode.classList.contains('content') || element.parentNode.classList.contains('pup-history')) {
                                element.parentNode.parentNode.remove();
                            } else {
                                element.parentNode.remove();
                            }

                            // If the Price Change section is also absent, the tab is empty — hide it
                            if (priceHistoryTab && !priceHistoryTab.querySelector('.w_pricehistory_flexbox')) {
                                var popup = priceHistoryTab.closest('.w_popup');
                                if (popup) {
                                    var tabLink = popup.querySelector('a.price_history[data-tab]');
                                    if (tabLink) {
                                        var wasActive = tabLink.classList.contains('_active');
                                        tabLink.style.display = 'none';

                                        if (wasActive) {
                                            priceHistoryTab.classList.remove('_active');
                                            var firstLink = popup.querySelector('.lst_links a[data-tab]:not([style*="display:none"]):not([style*="display: none"])');
                                            if (firstLink) firstLink.click();
                                        }
                                    }
                                }
                            }
                        }
                    }
                }).finally(function () {
                    ctrl.loadingData = false;
                });
            };
        }
    ]
});